// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveLinkController from "./active_link_controller"
application.register("active-link", ActiveLinkController)

import AddressFieldsController from "./address_fields_controller"
application.register("address-fields", AddressFieldsController)

import ButtonSubmitController from "./button_submit_controller"
application.register("button-submit", ButtonSubmitController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CloudflareTurnstileController from "./cloudflare_turnstile_controller"
application.register("cloudflare-turnstile", CloudflareTurnstileController)

import CodeAreaController from "./code_area_controller"
application.register("code-area", CodeAreaController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import Development__DirectUploadController from "./development/direct_upload_controller"
application.register("development--direct-upload", Development__DirectUploadController)

import Development__PaypalCheckoutController from "./development/paypal_checkout_controller"
application.register("development--paypal-checkout", Development__PaypalCheckoutController)

import Development__PaystackCheckoutController from "./development/paystack_checkout_controller"
application.register("development--paystack-checkout", Development__PaystackCheckoutController)

import Development__StripeCheckoutController from "./development/stripe_checkout_controller"
application.register("development--stripe-checkout", Development__StripeCheckoutController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DiscountFormController from "./discount_form_controller"
application.register("discount-form", DiscountFormController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FileFieldController from "./file_field_controller"
application.register("file-field", FileFieldController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FormAccordionController from "./form_accordion_controller"
application.register("form-accordion", FormAccordionController)

import JsonDisplayController from "./json_display_controller"
application.register("json-display", JsonDisplayController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MockController from "./mock_controller"
application.register("mock", MockController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import PaypalController from "./paypal_controller"
application.register("paypal", PaypalController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import SwapFormController from "./swap_form_controller"
application.register("swap-form", SwapFormController)

import TabPanelsController from "./tab_panels_controller"
application.register("tab-panels", TabPanelsController)

import ToggleSidebarController from "./toggle_sidebar_controller"
application.register("toggle-sidebar", ToggleSidebarController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
